import { WorkflowVariable, WorkflowComponentParamType, StoredProcedureScope } from '@cloud-native/workflows-engine'

export const isExpression = (expression?: string) =>
  (expression?.includes('{{') && expression?.includes('}}')) as boolean

export const isExpressionOpening = (expression?: unknown) => String(expression).indexOf('{{') === 0

export const isExpressionWithVariableOpening = (expression?: unknown) =>
  String(expression).indexOf('{{') === 0 && String(expression).includes('@')

export const filterVariables = (params: {
  variables: WorkflowVariable[]
  matcher: string
  type: WorkflowComponentParamType
}) =>
  params.variables
    .filter((variable) => variable.type === params.type)
    .filter((variable) =>
      variable.name
        .toLowerCase()
        .includes(String(params.matcher).replaceAll('{{', '').replaceAll('@', '').toLowerCase())
    )

export const extractVariables = (stringValue: string) => {
  const regex = /{{@(\w+)}}/g

  return [...stringValue.matchAll(regex)].map((match) => match[1])
}

export const getNewVariables = (variables1: string[], variables2: string[]) => {
  const newVariables = [...variables1]

  variables2.forEach((variable) => {
    const index = newVariables.indexOf(variable)
    if (index !== -1) {
      newVariables.splice(index, 1)
    }
  })

  return newVariables
}

export const isScopeApi = (scopes: StoredProcedureScope[]) => scopes.includes(StoredProcedureScope.Api)

export const isApiVariable = (variable: WorkflowVariable) => isScopeApi(variable.scopes)

export const getApiVariables = (variables: WorkflowVariable[] | undefined) =>
  (variables || []).filter((variable) => isApiVariable(variable))

export const isScopeMcpTool = (scopes: StoredProcedureScope[]) => scopes.includes(StoredProcedureScope.McpTool)

export const isMcpToolVariable = (variable: WorkflowVariable) => isScopeMcpTool(variable.scopes)

export const getMcpToolVariables = (variables: WorkflowVariable[] | undefined) =>
  (variables || []).filter((variable) => isMcpToolVariable(variable))

export const isScopeViewerMode = (scopes: StoredProcedureScope[]) => scopes.includes(StoredProcedureScope.Viewer)

export const isViewerModeVariable = (variable: WorkflowVariable) => isScopeViewerMode(variable.scopes)

export const getViewerModeVariables = (variables: WorkflowVariable[] | undefined) =>
  (variables || []).filter((variable) => isViewerModeVariable(variable))
